module.exports = __webpack_public_path__ + "fonts/effect-mystic-observation-d95905.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-mystic-observation.svg
// module id = 800
// module chunks = 0